export default __webpack_public_path__ + "static/media/look-out-blue.4aedd663.jpg";